import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  // 索引城市选择
  {
    path: '/courierView/indexesCitySelect',
    component: Loadable({
      loader: () => import('@/pages/indexesCitySelect'),
      loading: LoadingComponent
    }),
    meta: {
      title: '选择城市'
    }
  }
]
